import { CommonErrorBanner } from 'pages/settings/pages/compliance/ui/CommonErrorBanner/CommonErrorBanner'
import { useBusinessProfileStepsContext } from 'pages/settings/pages/compliance/pages/businessProfile/context/businessProfileStepsContext'

export const ErrorBanner = () => {
  const { errorMessage } = useBusinessProfileStepsContext()

  return <CommonErrorBanner errorMessage={errorMessage} />
}
